import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = ["disabled"]

import { ref, computed, toRef } from 'vue'
    import { MonthPicker } from 'vue-month-picker'

    import type { MonthYear } from '@common/types'
    import { MonthYearHelpers } from '@common/types'
    import type { MonthPickerDate, MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MonthPickerDialog',
  props: {
    viewModel: {}
  },
  emits: ["update-date"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const date = ref<MonthPickerDate | null>(null)

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.isOpened ?? false)
    const title = computed(() => vm.value.title)
    const description = computed(() => vm.value.description)

    const defaultYear = computed(() => vm.value.defaultDate?.Year ?? null)
    const defaultMonth = computed(() => vm.value.defaultDate?.Month ?? null)

    const canConfirm = computed(() =>
        vm.value.valueRequired === true
            ? date.value != null
            : true
    )

    // ---------------- handlers ----------------

    function onDateChange(d: MonthPickerDate)
    {
        date.value = d
    }

    function onDateClear()
    {
        date.value = null
    }

    function confirm()
    {
        const result =
            date.value == null
                ? null
                : MonthYearHelpers.build(date.value.year, date.value.monthIndex)

        emit('update-date', result)
        close()
    }

    function close()
    {
        vm.value.close()
        date.value = null
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (description.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(description.value), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createVNode(_unref(MonthPicker), {
                  onClear: onDateClear,
                  onChange: onDateChange,
                  clearable: true,
                  "no-default": vm.value.defaultDate == null,
                  "default-month": defaultMonth.value,
                  "default-year": defaultYear.value
                }, null, 8 /* PROPS */, ["no-default", "default-month", "default-year"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: confirm,
                  disabled: canConfirm.value === false,
                  type: "button",
                  class: "btn btn-primary"
                }, "Confirm", 8 /* PROPS */, _hoisted_10)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})